import Image from 'next/image'

export default function DeepConfidenceIcon( { complete } ) {
  // const { bg, fg1, fg2 } = getIconColors( complete )
  
  return (
    <Image width={ 100 } height={ 100 } sizes="100vw" style={ { width: '100%', aspectRatio: '1' } } src={ complete ? '/images/icons/deep-confidence-colour.png' : '/images/icons/deep-confidence-grey.png' } alt="Deep confidence icon" />  
  )
}
